import { Navigate, useParams } from 'react-router-dom';
import { useGetRetencion } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveRetencion } from '../../shared/saveRetencion';

export interface UpdateRetencionesPageInterface {}

const UpdateRetencionesPage: React.FC<UpdateRetencionesPageInterface> = () => {
  /* useCheckPermissions(PermissionsEnum.api_change_Retencion) */
  const { id } = useParams();
  const { data, isLoading } = useGetRetencion(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_retencion) return <Navigate to="/compras/retenciones" />;

  return <SaveRetencion titlePage="Editar Retenciones" editRetencion={data.data} />;
};

export default UpdateRetencionesPage;
